
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saved-items/[slug]",
      function () {
        return require("private-next-pages/saved-items/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/saved-items/[slug]"])
      });
    }
  